const MILLISECONDS_IN_HOUR = 3600000;
const Cookies = {
    set(name, value, time) {
        if (name === undefined) {
            return;
        }
        let cookie = `${name}=${value || ''};path=/`;
        if (time !== undefined) {
            const expire = new Date();
            expire.setTime(expire.getTime() + time * MILLISECONDS_IN_HOUR);
            cookie += `;expires=${expire.toUTCString()}`;
        }
        document.cookie = cookie;
    },
    get(name) {
        const result = this.getAll()
            .reverse()
            .find((cookie) => cookie.name === name);
        return result?.value ?? null;
    },
    getAll() {
        const cookies = document.cookie ? document.cookie.split('; ') : [];
        return cookies.map((cookie) => {
            const parts = cookie.split('=');
            let value;
            try {
                value = decodeURIComponent(parts[1]);
            }
            catch {
                value = parts[1];
            }
            return {
                name: parts[0],
                value,
            };
        });
    },
    remove(name) {
        this.set(name, '', -1);
    },
};

export { Cookies };
//# sourceMappingURL=index.js.map
